export default __webpack_public_path__ + "static/media/Loader2.1749917b.gif";